import React from "react";
import { Lotus } from "./Lotus";

function HeaderPrescription({
  clinicDetails,
  doctorData,
  hospitalAccountData,
}) {
  return (
    <>
      {clinicDetails?.prescription_HeaderYN === "Y" ||
      (clinicDetails?.prescription_HeaderYN === "C" &&
        !doctorData.headerDetails) ? (
        <div className="border-b-2 border-gray-300 flex justify-between items-start">
          {clinicDetails?.clinicDetailsInPrescriptionYN === "Y" ? (
            <div>
              <div className="flex">
                <img
                  src={"data:image/jpeg;base64," + hospitalAccountData?.logoB64}
                  alt="Clinic Logo"
                  className="w-24 w-14 h-24 h-14 mx-4 mx-2"
                />
                <div className="text-center ">
                  <label className="text-4xl text-2xl font-serif font-medium text-[#154A6B]">
                    {clinicDetails?.clinic_Name}
                  </label>
                </div>
              </div>
              <div className="flex gap-3 my-2">
                {(clinicDetails?.morningFromTime ||
                  clinicDetails?.morningToTime) && (
                  <p className="text-sm text-[#A7527E] font-medium mt-4">
                    Morning:
                    <span className="text-[#184B67]">{` ${clinicDetails?.morningFromTime} - ${clinicDetails?.morningToTime} `}</span>
                  </p>
                )}
                {(clinicDetails?.eveningFromTime ||
                  clinicDetails?.eveningToTime) && (
                  <p className="text-sm text-[#A7527E] font-medium mt-4">
                    Evening:
                    <span className="text-[#184B67]">
                      {` ${clinicDetails?.eveningFromTime} - ${clinicDetails?.eveningToTime} `}{" "}
                    </span>
                  </p>
                )}
              </div>
            </div>
          ) : (
            <div>&nbsp;</div>
          )}
          <div className="text-right text-[#184B67]">
            <label className="text-2xl text-sm font-bold text-[#244D67]">
              {doctorData?.userSalutation} {doctorData?.userFirstName}{" "}
              {doctorData?.userLastName}
            </label>
            <p className=" text-[#244D67] font-medium">
              <span className="text-xs"> {doctorData?.qualification}</span>
              <br />
              <span className="text-xs font-medium text-[#244D67]">
                {doctorData?.speciality}
              </span>
              <br />
              {doctorData?.registrationNumber && (
                <span>Reg.no.{doctorData?.registrationNumber}</span>
              )}
            </p>
          </div>
        </div>
      ) : clinicDetails?.prescription_HeaderYN === "C" &&
        doctorData.headerDetails ? (
        <div
          dangerouslySetInnerHTML={{
            __html: atob(doctorData.headerDetails).replace(
              /className=/g,
              "class="
            ),
          }}
        />
      ) : clinicDetails?.prescription_HeaderYN === "N" ? (
        <div
          style={{
            height: `${clinicDetails.prescription_Header_Space}px`,
          }}
          className="h-auto"
        ></div>
      ) : (
        ""
      )}
    </>
  );
}

export default HeaderPrescription;
